module.exports = __webpack_public_path__ + "img/yzh3.958ea97a.jpg";